import query from "./QueryHelper";
import api from "./ApiHelper";

export default class Popup {
  constructor(videoPlayer) {
    this.$popup = $("[data-popup]");
    this.$openBtn = $("[data-open-popup]");
    this.$closeBtn = $(".js-close-popup");
    this.videoPlayer = videoPlayer;
  }

  async init() {
    let self = this;

    let queryPopup = query.read("popup");
    if(queryPopup && queryPopup === "marker") {
      let $popup = $("[data-popup='" + queryPopup + "']");
      let markerId = query.read("post-id");
      let markerHtml = await api.getPost(markerId);
      $popup.html(markerHtml);
      self.openPopup($popup);
    } else {
      query.remove(["popup"]);
    }

    this.$openBtn.click(function(e) {
      e.preventDefault();
      let type = $(e.currentTarget).data("open-popup");
      let $popup = $("[data-popup='" + type + "']");
      let src = $(e.currentTarget).data("popup-src");

      if(type === "video") {
        $popup.find("video")[0].src = src;
        setTimeout(() => {
          self.videoPlayer.initVideos();
        }, 200);
      }

      if(type === "image") {
        $popup.find("img")[0].src = src;
      }

      self.openPopup($popup);
    });

    this.$closeBtn.click(function(e) {
      e.preventDefault();
      let $popup = $(e.currentTarget).parents("[data-popup]");
      self.closePopup($popup);
    });

    this.$popup.click(function(e) {
      if(e.target === e.currentTarget) {
        let $popup = $(e.target);
        self.closePopup($popup);
      }
    });

    self.closePopup($popup);
  }

  openPopup($popup) {
    let self = this;
    $popup.addClass("open");
    $("html").css("overflow-y", "hidden");
    $("main, .page-header, footer").addClass("blurred");
    if($popup.data("popup") === "marker") {
      query.update({popup: $popup.data("popup")});
    }
    if($popup.data("popup") === "video") {
      setTimeout(() => {
        self.videoPlayer.update($popup.find(".js-video"), true);
      }, 400);
    }
  }

  closePopup($popup) {
    $popup.removeClass("open");
    $("html").css("overflow-y", "scroll");
    if($popup.data("popup") === "marker") {
      query.remove(["popup", "post-id"]);
    }
    $("main, .page-header, footer").removeClass("blurred");
    if($popup.data("popup") === "video") {
      this.videoPlayer.update($popup.find(".js-video"), false);
    }
  }
}



// WEBPACK FOOTER //
// ./static/js/components/Popup.js